import React from "react";
import { Link } from "react-router-dom";
import { Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

const { Text } = Typography;

const Foot = () => {
  return (
    <div className="bg-darkMode-background border-t border-1 border-darkMode-layer2 px-4 py-2">
      <footer className="flex flex-row items-center justify-between">
        <Text className="text-darkMode-text text-md">
          &copy; 2025 Market Pulse
        </Text>
        <div className="flex space-x-4">
          <Link
            to="https://facebook.com"
            target="_blank"
            className="text-blue-400"
          >
            <FontAwesomeIcon icon={faFacebook} size="lg" />
          </Link>
          <Link
            to="https://twitter.com"
            target="_blank"
            className="text-blue-300"
          >
            <FontAwesomeIcon icon={faTwitter} size="lg" />
          </Link>
          <Link
            to="https://linkedin.com"
            target="_blank"
            className="text-blue-500"
          >
            <FontAwesomeIcon icon={faLinkedin} size="lg" />
          </Link>
        </div>
        <Text className="text-gray-400 text-sm">
          Made with <span className="text-red-500">❤</span> by Delpat
        </Text>
      </footer>
    </div>
  );
};

export default Foot;
